import { buildGlobalAction } from "./../builder.js";
class OnetimerunNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the activateBlockingForAllStores global action. */
    this.activateBlockingForAllStores = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "activateBlockingForAllStores",
      operationName: "activateBlockingForAllStores",
      operationReturnType: "OneTimeRunActivateBlockingForAllStores",
      namespace: "oneTimeRun",
      variables: {}
    });
    /** Executes the cleanWrongLeakSourceName global action. */
    this.cleanWrongLeakSourceName = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "cleanWrongLeakSourceName",
      operationName: "cleanWrongLeakSourceName",
      operationReturnType: "OneTimeRunCleanWrongLeakSourceName",
      namespace: "oneTimeRun",
      variables: {}
    });
    /** Executes the deduplicateLeakedCodeSources global action. */
    this.deduplicateLeakedCodeSources = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "deduplicateLeakedCodeSources",
      operationName: "deduplicateLeakedCodeSources",
      operationReturnType: "OneTimeRunDeduplicateLeakedCodeSources",
      namespace: "oneTimeRun",
      variables: {}
    });
    /** Executes the disableCustomerWebhook global action. */
    this.disableCustomerWebhook = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "disableCustomerWebhook",
      operationName: "disableCustomerWebhook",
      operationReturnType: "OneTimeRunDisableCustomerWebhook",
      namespace: "oneTimeRun",
      variables: {}
    });
    /** Executes the followUpEmailShopList global action. */
    this.followUpEmailShopList = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "followUpEmailShopList",
      operationName: "followUpEmailShopList",
      operationReturnType: "OneTimeRunFollowUpEmailShopList",
      namespace: "oneTimeRun",
      variables: { shopList: { required: false, type: "[String!]" } }
    });
    /** Executes the getStoresWithoutThemeExtensionInstalled global action. */
    this.getStoresWithoutThemeExtensionInstalled = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getStoresWithoutThemeExtensionInstalled",
      operationName: "getStoresWithoutThemeExtensionInstalled",
      operationReturnType: "OneTimeRunGetStoresWithoutThemeExtensionInstalled",
      namespace: "oneTimeRun",
      variables: {}
    });
    /** Executes the leakedCodeCleanup global action. */
    this.leakedCodeCleanup = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "leakedCodeCleanup",
      operationName: "leakedCodeCleanup",
      operationReturnType: "OneTimeRunLeakedCodeCleanup",
      namespace: "oneTimeRun",
      variables: {}
    });
    /** Executes the leakedCodesUpdate global action. */
    this.leakedCodesUpdate = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "leakedCodesUpdate",
      operationName: "leakedCodesUpdate",
      operationReturnType: "OneTimeRunLeakedCodesUpdate",
      namespace: "oneTimeRun",
      variables: { shopId: { required: false, type: "String" } }
    });
    /** Executes the runOrdersBulkQueryFrom2024OctForEachShop global action. */
    this.runOrdersBulkQueryFrom2024OctForEachShop = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "runOrdersBulkQueryFrom2024OctForEachShop",
      operationName: "runOrdersBulkQueryFrom2024OctForEachShop",
      operationReturnType: "OneTimeRunRunOrdersBulkQueryFrom2024OctForEachShop",
      namespace: "oneTimeRun",
      variables: {}
    });
    /** Executes the runOrdersBulkQueryFrom60DaysAgoForEachShop global action. */
    this.runOrdersBulkQueryFrom60DaysAgoForEachShop = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "runOrdersBulkQueryFrom60DaysAgoForEachShop",
      operationName: "runOrdersBulkQueryFrom60DaysAgoForEachShop",
      operationReturnType: "OneTimeRunRunOrdersBulkQueryFrom60DaysAgoForEachShop",
      namespace: "oneTimeRun",
      variables: {}
    });
    /** Executes the sethighRiskCodeMinimumForAllShops global action. */
    this.sethighRiskCodeMinimumForAllShops = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sethighRiskCodeMinimumForAllShops",
      operationName: "sethighRiskCodeMinimumForAllShops",
      operationReturnType: "OneTimeRunSethighRiskCodeMinimumForAllShops",
      namespace: "oneTimeRun",
      variables: {}
    });
    /** Executes the syncOrdersToTinybird global action. */
    this.syncOrdersToTinybird = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "syncOrdersToTinybird",
      operationName: "syncOrdersToTinybird",
      operationReturnType: "OneTimeRunSyncOrdersToTinybird",
      namespace: "oneTimeRun",
      variables: {}
    });
    /** Executes the syncOrdersToTinybirdInBulk global action. */
    this.syncOrdersToTinybirdInBulk = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "syncOrdersToTinybirdInBulk",
      operationName: "syncOrdersToTinybirdInBulk",
      operationReturnType: "OneTimeRunSyncOrdersToTinybirdInBulk",
      namespace: "oneTimeRun",
      variables: { shopId: { required: false, type: "String" } }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  OnetimerunNamespace
};
//# sourceMappingURL=oneTimeRun.js.map
